import  Authi18n  from "./authi18n";

const en: Authi18n = {
  namespace: "core/modules/auth",
  sign: "Sign in",
  getData: "Get Data",
  askAccount: "Don't have an account?",
  signUp: "Sign up here!",
  rememberMe: "Remember me",
  forgotPassword: "Forgot Password?",
  password: "Password",
  username: "Login",
  firstName: "First name",
  secondName: "Second name",
  partialName: "Partial name",
  confirmPassword: "Confirm password",
  post: "Post",
  email: "Email",
  role: "Roles",
  notValidData: "Login or Password Not Correct",
  usernameOrMail: "Login or Email",
  company: "Company:",
  phone: "Phone",
  inputUsernameOrMail: "Enter login or email",
  inputPassword: "Enter password",
  validate:{
    empty: "This field is required"
  }
};

export default en;
